/*
  XADV — minimumbestelbedrag op de winkelwagenpagina (snippets/xadv-min-order.liquid).
  1. Houdt Checkout en de express-knoppen uit zolang de melding in de cart-footer staat.
     De thema-JS vervangt bij elke wijziging alleen het subtotaal-blok, dus de knoppen
     worden hier bijgewerkt via een MutationObserver.
  2. Snel toevoegen van de suggesties: /cart/add.js, daarna laat de <cart-items> van het
     thema de winkelwagen opnieuw renderen (fallback: pagina herladen).
*/
(function () {
  if (window.__xadvMinOrder) return;
  window.__xadvMinOrder = true;

  function sync() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    var below = !!footer.querySelector('.xadv-min');
    var checkout = footer.querySelector('#checkout');
    if (checkout) checkout.disabled = below || footer.classList.contains('is-empty');
    footer.querySelectorAll('.cart-dynamic-checkout-buttons').forEach(function (el) {
      el.hidden = below;
    });
  }

  function watch() {
    var footer = document.getElementById('main-cart-footer');
    if (!footer) return;
    sync();
    new MutationObserver(sync).observe(footer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element ? event.target.closest('[data-xadv-min-add]') : null;
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;

    var addUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url + '.js' : '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.xadvMinAdd), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add ' + response.status);
        document.dispatchEvent(new CustomEvent('cart:updated'));
        var cartItems = document.querySelector('cart-items');
        if (cartItems && typeof cartItems.updateSectionContents === 'function') {
          return cartItems.updateSectionContents();
        }
        window.location.reload();
      })
      .catch(function (error) {
        console.error('[xadv-min-order]', error);
        button.disabled = false;
      });
  });
})();
